type LocatableAsset = {
  deployment?: {
    location?: { id?: string | null } | null;
  } | null;
};

export function assetIsAtLocation(
  asset: LocatableAsset,
  targetLocationId?: string
): boolean {
  if (!targetLocationId) return true;

  const deployment = asset.deployment;
  if (!deployment?.location) return false;

  const locationId = targetLocationId.includes(':')
    ? targetLocationId.split(':')[1]
    : targetLocationId;

  return deployment.location.id === locationId;
}
